<template>
  <div class="container max-h-max">
    <div class="md:my-20 mx-auto max-w-2xl">
      <form
        class="content-center border-2 border-black rounded-xl p-8 bg-white home-vips-item"
        @submit.prevent="submit"
      >
        <div class="text-center text-bold text-3xl md:text-4xl">
          Nodig je vrienden uit deze zomer met de AI avatar van Tom Coronel!
        </div>
        <div class="text-center text-2xl">
          (tijdelijk gratis!)
        </div>

        <div class="my-4">
          <div class="mx-auto md:flex">
            <VideoPlayer
              controls
              src="/videos/tom-ai.mp4"
              poster="/images/tom-ai.png"
              class="rounded-lg border-2 border-red grow"
              width="400"
              height="400"
            />
            <div class="md:ml-[15px] mt-2 md:mt-[90px]">
              <div class="text-red font-bold text-lg">
                {{ vip.content.display_name }}
              </div>
              <div class="text-black">
                {{ vip.content.tag_line }}
              </div>
            </div>
          </div>
        </div>

        <div class="mt-2">
          <TextareaField
            v-model="form.script"
            :form="form"
            classes="border bg-gray-100"
            name="script"
            label="Script:"
            :disabled="true"
          />
        </div>

        <div class="mt-2 grid grid-cols-2 gap-4">
          <div>
            <InputField
              v-model="form.name"
              :form="form"
              classes="border"
              name="name"
              type="text"
              label="Voornaam:"
              placeholder="Jan"
            />
          </div>
          <div>
            <SelectField
              v-model="form.activity"
              :form="form"
              classes="border"
              name="activity"
              label="Activiteit:"
              maxlength="255"
              :options="activities"
            />
          </div>
        </div>

        <div class="mt-2">
          <InputField
            v-model="form.email"
            :form="form"
            classes="border"
            name="email"
            type="email"
            label="Email:"
            placeholder="janbakker@gmail.com"
            maxlength="255"
          />
        </div>

        <div class="mt-2">
          <InputField
            v-model="form.phone"
            :form="form"
            classes="border"
            name="phone"
            type="tel"
            label="Telefoonnummer:"
            placeholder="06 12 34 56 78"
            maxlength="255"
            :is-required="false"
          />
        </div>

        <div class="mt-4 flex">
          <button
            type="submit"
            class="mx-auto button-green shadow-button-black w-full block lg:w-auto lg:inline-block lg:px-16"
          >
            <span v-if="form.processing">
              <img
                src="/frontend/assets/spinner.svg"
                class="h-6 w-6 animate-spin"
              >
            </span>
            <span v-else>
              Bestel AI avatar video nu
              <img
                src="/frontend/assets/white-arrow.svg"
                class="inline ml-2"
              >
            </span>
          </button>
        </div>

        <div class="mt-8 w-full text-center text-xs">
          Nu besteld is binnen 12 uur een video
        </div>
      </form>

      <span class="mt-8 text-xs block">
        {{ __('index.known-from') }}
      </span>

      <div class="mt-2 flex justify-between space-x-3 lg:space-x-6 items-center">
        <div class="w-20">
          <img src="/frontend/assets/ing.png">
        </div>
        <div class="w-20">
          <img src="/frontend/assets/postnl.png">
        </div>
        <div class="w-20">
          <img src="/frontend/assets/sbs-6.png">
        </div>
        <div class="w-20">
          <img src="/frontend/assets/thuisbezorgd.png">
        </div>
        <div class="w-20">
          <img src="/frontend/assets/pathe.svg">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {useForm} from '@inertiajs/vue3';
import DefaultWithoutFooter from '../../../Layout/DefaultWithoutFooter.vue';
import InputField from '../../../Components/Form/InputField.vue';
import SelectField from '../../../Components/Form/SelectField.vue';
import TextareaField from '../../../Components/Form/TextareaField.vue';
import VideoPlayer from '../../../Components/VideoPlayer.vue';

export default {
  components: {VideoPlayer, InputField, SelectField, TextareaField},

  layout: DefaultWithoutFooter,

  props: {
    vip: {
      type: Object,
      required: true,
    },

    scripts: {
      type: Array,
      required: true,
    },

    activities: {
      type: Array,
      required: true,
    },
  },

  setup (props) {
    const form = useForm({
      vip_id: props.vip.id,
      script: props.scripts[0].value,
      name: '',
      email: '',
      phone: '',
      activity: props.activities[0].key,
    });

    return {form};
  },

  methods: {
    submit() {
      return this.form.post(this.localeRoute('frontend.shout-out-ai.create'));
    },
  },
};
</script>
